import type { HighlightReview } from '@/types/models'
import { SPOTLIGHT_BLOCK_REVIEW_COUNT } from './constants'
import { isNonEmptyArray } from '@/utils/checks'

export const getUniqueReviews = (
  reviews?: HighlightReview[]
): HighlightReview[] => {
  if (!isNonEmptyArray(reviews)) {
    return []
  }
  const includedCenters = new Set<string>()
  const uniqueReviews = reviews.filter((review: HighlightReview) => {
    if (!review._center || !review._center.slug) return false
    if (includedCenters.size === SPOTLIGHT_BLOCK_REVIEW_COUNT) return false
    if (!includedCenters.has(review._center.slug)) {
      includedCenters.add(review._center.slug)
      return true
    }
    return false
  })
  return uniqueReviews
}
